import { CrewListsScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeCrewListSource } from '../crew-lists-source.js';

/** Crew ▸ Crew Lists (IMO FAL Form 5; ADR 0130 §B): ofiste gemi seçilir, liste hazırlanır. */
export function CrewListsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.crewLists')}>
      <CrewListsScreen source={officeCrewListSource} />
    </Shell>
  );
}
